/**
 * The sentences the bulk Review Lot & NDC screen says about the BATCH.
 *
 * Split from bulkLotNdcStatus, which answers the other question — what is true of one ROW.
 */

import { compareAlphabetically } from './bulkLotNdcReviewFiltering';
import { statusLabelFor } from './bulkLotNdcStatusLabels';

/**
 * POM-6534 — how many rows carry each status, in the grid's own chip words: "2 Expired lot · 1 No
 * NDC". Chip words rather than a separate vocabulary, so the sentence names exactly what the rows
 * above it show.
 *
 * Largest count first, then A–Z: the biggest problem leads, which is a deliberate exception to the
 * plain alphabetical rule.
 */
export const statusCountsSummary = (rows) => {
  const countByLabel = new Map();
  (rows ?? []).forEach((row) => {
    const label = statusLabelFor(row);
    countByLabel.set(label, (countByLabel.get(label) ?? 0) + 1);
  });

  return [...countByLabel.entries()]
    .sort(
      ([leftLabel, leftCount], [rightLabel, rightCount]) =>
        rightCount - leftCount || compareAlphabetically(leftLabel, rightLabel)
    )
    .map(([label, count]) => `${count} ${label}`)
    .join(' · ');
};

export default statusCountsSummary;
